import { render, staticRenderFns } from "./PlatformAnalyticsView.vue?vue&type=template&id=0d6ab0f2&scoped=true"
import script from "./PlatformAnalyticsView.vue?vue&type=script&lang=js"
export * from "./PlatformAnalyticsView.vue?vue&type=script&lang=js"
import style0 from "./PlatformAnalyticsView.vue?vue&type=style&index=0&id=0d6ab0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6ab0f2",
  null
  
)

export default component.exports